module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items) ? _c('div', {
    staticClass: "modulefooter"
  }, [(_vm.items.themes) ? _c('ModuleFooterList', {
    attrs: {
      "title": "Темы",
      "list": _vm.items.themes
    }
  }) : _vm._e(), (_vm.items.knows) ? _c('ModuleFooterList', {
    attrs: {
      "title": "Что будете знать",
      "list": _vm.items.knows
    }
  }) : _vm._e(), (_vm.items.skills) ? _c('ModuleFooterList', {
    attrs: {
      "title": "Что будете уметь",
      "list": _vm.items.skills
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b34bdb4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/modulefooter/ModuleFooter.vue
// module id = 2b0fc81e9003eb9371f2
// module chunks = 0